export enum CodStateSignature {
  Verified = '4',
}
